import Button from '@/components/Button';
import { Stack } from '@/components/Layout';
import Text from '@/components/Text';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect } from 'react';
export const root = "rvqcmto";
const ErrorReloadDelayMillis = 3 * 1000; // Wait 3 seconds before reloading.
const ErrorReloadRateLimitMillis = 60 * 1000; // At most 1 reload per minute.
const ErrorReloadTimeStorageKey = '@gsu/web:error:reload-time'; // When the most recent reload occurred.
const ErrorPathStorageKey = '@gsu/web:error:path'; // Router pathname the most recent error occurred on.

function isSessionStorageEnabled(): boolean {
  // Browsers may disable Session Storage. Normally this rare edge case would not be worth checking,
  // but since we're already in an error case, try to be as safe as possible.
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return false;
  }
}
const ErrorMessage: React.FC = () => {
  const router = useRouter();
  const handleOnClick = useCallback(() => {
    window.location.reload();
  }, []);
  useEffect(() => {
    // Try to fix the error by automatically soft-reloading the page once,
    // rather than asking the user to click on the button. Most of the time, this should work.
    //
    // For some errors, e.g. failure to load Next.js `_buildManifest.js`, the soft-reload is in fact a hard-reload.
    // Enforce a rate limit to avoid an infinite reload loop in this case.
    if (isSessionStorageEnabled()) {
      if (router.pathname !== window.sessionStorage.getItem(ErrorPathStorageKey)) {
        // You switched to a different page. You probably got a different error. Reset the rate limit.
        window.sessionStorage.removeItem(ErrorReloadTimeStorageKey);
        window.sessionStorage.setItem(ErrorPathStorageKey, router.pathname);
      }
      const now = Date.now();
      const rawStoredReloadTime = window.sessionStorage.getItem(ErrorReloadTimeStorageKey);
      const storedReloadTime = rawStoredReloadTime && parseInt(rawStoredReloadTime, 10);
      if (!storedReloadTime || now - storedReloadTime > ErrorReloadRateLimitMillis) {
        window.sessionStorage.setItem(ErrorReloadTimeStorageKey, `${now}`);
        setTimeout(() => router.replace(router.asPath), ErrorReloadDelayMillis);
      }
    }
  }, []);
  return <div className={root}>
      <Stack alignItems="center" justifyContent="center" spaceBetweenY="md" y>
        <Stack alignItems="center" justifyContent="center" y>
          <Text size="md" weight="lg">
            Sorry, we've hit a snag.
          </Text>
          <Text size="xs" weight="sm">
            Please try reloading the page in a few seconds.
          </Text>
        </Stack>
        <Button iconLeft="retry" iconSize={20} label="Reload" size="md" onClick={handleOnClick} />
      </Stack>
    </div>;
};
export default ErrorMessage;

require("./index.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");